var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBehanceLogo = function SvgIconBehanceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.625 6a1 1 0 0 1 1-1h4.688a3.812 3.812 0 0 1 3.053 6.095 4.18 4.18 0 0 1 2.259 3.717A4.187 4.187 0 0 1 8.438 19H2.625a1 1 0 0 1-1-1zm2 6.625V17h4.813a2.188 2.188 0 0 0 0-4.375zm3.688-2H3.625V7h3.688a1.813 1.813 0 0 1 0 3.625",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.125a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.568 9.862A4.75 4.75 0 1 0 18.748 19a4.7 4.7 0 0 0 2.081-.476 1 1 0 1 0-.877-1.798 2.7 2.7 0 0 1-1.198.274h-.004a2.75 2.75 0 0 1-2.562-1.75H22.5a1 1 0 0 0 1-1 4.75 4.75 0 0 0-2.932-4.388m.744 3.388h-5.124a2.749 2.749 0 0 1 5.124 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBehanceLogo;